import { FileExtension } from './../../dto/file-extension';
import { FileMetadata } from './../../dto/file-metadata';
import { FilesService } from './../../services/files/files.service';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { take, takeUntil } from 'rxjs/operators';
import { FileUploadResult } from '../../dto/file-upload-result';
import { Subject } from 'rxjs';
import { NgClass, NgIf, NgSwitch, NgSwitchCase, DatePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'pcp-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    imports: [NgClass, NgIf, NgSwitch, NgSwitchCase, MatIcon, DatePipe]
})
export class FileUploadComponent implements OnDestroy, OnChanges {
  constructor(private service: FilesService) {}

  @Input() value: string | null = null;
  @Input() accept: string | null = null;
  @Output() valueChange = new EventEmitter<string>();

  error: string | null = null;
  progress: number | null = null;
  extension = FileExtension;
  fileData: FileMetadata | null = null;
  isUploading = false;
  onDestroy$ = new Subject<void>();

  fileSelect(event: { target: { files: File[] | null } }) {
    if (event.target.files && event.target.files.length > 0) {
      this.progress = 0;
      this.isUploading = true;
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('file', file);

      this.service
        .uploadFile(formData)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (res: FileUploadResult[] | { progress: number } | null) => {
            if (res === null) {
              return;
            }
            if ((<FileUploadResult[]>res).length) {
              const result = res as FileUploadResult[];
              if (result.length > 0) {
                this.value = result[0].fileId;
                this.getFileMetadata(this.value);
                this.isUploading = false;
                this.valueChange.emit(this.value);
              }
            } else {
              this.progress = (<{ progress: number }>res).progress;
            }
          },
          (err: string | null) => (this.error = err)
        );
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (propName === 'value') {
        const val = changes[propName].currentValue;
        if (val) {
          this.getFileMetadata(val);
        }
      }
    }
  }
  ngOnDestroy() {
    this.onDestroy$.next();
  }

  getFileMetadata(fileId: string) {
    this.service
      .getFileMetadata(fileId)
      .pipe(take(1))
      .subscribe((f) => (this.fileData = f));
  }
}
